module.exports = __webpack_public_path__ + "static/media/banner-phone-officeWarszawa.512d2e91.jpg";